import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';

import { AuthGuardService } from '@unico-people/shared/form/data-access-auth';

const appRoutes: Routes = [
  {
    path: 'callback',
    loadChildren: () => import('@unico-people/feature-callback').then(m => m.FeatureCallbackModule)
  },
  {
    path: 'inicio',
    loadChildren: () => import('@unico-people/feature-onboarding').then(m => m.FeatureOnboardingModule)
  },
  {
    path: 'profile/intro/:token',
    loadChildren: () => import('@unico-people/feature-invite').then(m => m.FeatureInviteModule)
  },
  {
    path: 'listing',
    loadChildren: () => import('@unico-people/candidate-benefits').then(m => m.BenefitsModule),
  },
  {
    path: 'benefits',
    loadChildren: () => import('@unico-people/candidate-benefits').then(m => m.BenefitsListingModule),
  },
  {
    path: 'benefit',
    loadChildren: () => import('@unico-people/candidate-benefits').then(m => m.BenefitsModule),
    canActivate: [AuthGuardService]
  },
  {
    path: '**',
    loadChildren: () => import('@unico-people/feature-not-found').then(m => m.FeatureNotFoundModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {
      preloadingStrategy: PreloadAllModules,
      relativeLinkResolution: 'legacy'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
